"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Timestamp_1 = require("../../model/types/Timestamp");
var UuidV4_1 = require("../../model/types/UuidV4");
var Browser_1 = require("../useragents/Browser");
var AbstractEvent = (function () {
    function AbstractEvent() {
        this.browser = new Browser_1.Browser();
        this.id = new UuidV4_1.UuidV4();
        this.timestamp = new Timestamp_1.Timestamp();
    }
    AbstractEvent.prototype.correctTimestamp = function (clockCorrection) {
        this.timestamp = new Timestamp_1.Timestamp(this.timestamp.toJSON() + clockCorrection);
    };
    return AbstractEvent;
}());
exports.AbstractEvent = AbstractEvent;
//# sourceMappingURL=AbstractEvent.js.map